import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import axios from 'axios';
// const querystring = require('querystring');

export default class ManageCircle extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
				let parms = "";
				//JSON.stringify(querystring.parse(this.props.location.search)).replace('?', '');
        console.log("parms => " + parms);

		this.state={
			circle : {
				"circlesId":JSON.parse(parms).id,
				"circleName":"",
				"circleDescription":"",
				"circleContacts":"",
				"circleTypeCode":0,
				"circleCategoryCode":0,
				"circleStatusCode":0,
				"contentId":0,
				"securityContextId":0,
				"createUser":0,
				"createDate":"",
				"lastUpdateUser":0,
				"lastUpdateDate":"",
				"ownerUserId":0
			},
			circleCategoryList : [],
			circleStatusList : [],
			circleContactTypeList : []
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleOnLoad = this.handleOnLoad.bind(this);
	}
	handleChange(event) {
		console.log(event);
		var target = event.target;
		console.log(target.id + ":" + target.value);
		this.setState({
			[target.id] : target.value
		});
	   
		console.log(this.state);
	  }
	handleSubmit(event) {

		event.preventDefault();
		console.log('handling submit');  
	
	  var url = `${global.config.apiServicesUrl}/circles`;
//	  var idUrl = "${global.config.securityServicesUrl}/next-id-generator/get-next/circles/circlesId";
	
//	  axios.get(idUrl)
//		  .then(response => {
//			  this.setState({generalledgerId : response.data["nextId"]});
//		  
//			  //console.log("new category id = " + JSON.stringifyt(this.state.circle.contentCategoriesObject.contentCategoryId));
//		
//			console.log("request object = " + JSON.stringify(this.state));
	  		this.state.circle.lastUpdateUser = Number(this.props.userId);

			axios
			  .post(url, this.state)
			  .then(response2 => {
			console.log("response.data");
			console.log(response2.status +":"+response2.data.accountId);
			// && response2.data.contentFacadeId === this.state.circle.contentFacadeId
			if (response2.status === 200 )
			{
				this.message = "Success";
			}
			else
			{
				 this.message = "Failed";
			}        
			console.log(this.message);
			 // 
			event.preventDefault();
			//response.send(this.message);
			
		  })
			  .catch(err => {
			 console.log("error - " + err);
		  });
			  console.log("message info - " + this.message); 
		this.handleClear();
			
		//});
		
		
			console.log("SetState Message info-"+this.contentFacadeTypeId);
			console.log("SetState Message info-"+this.contentFacadeName);
			
	 };
	 handleClear(){
		 this.setState({circle : {}})
	 }
	 componentDidMount() 
	 {
	 	this.handleOnLoad();
	 }

	handleOnLoad = () => {
		this.setState({circle : {}})	 
		 	//resolve drop down lists
			{
				//taskPriorityList
				var url1 = `${global.config.sharedServicesUrl}/code-catalog-data-service/get-system-code-values/CIRCLE_CATEGORIES`;
					axios.get(url1)
					.then(response =>{
 					this.setState({circleCategoryList : response.data});
					}).catch(function (error) {
						console.log("Error:"+error);
					});		
				//taskStatusList
				var url2 = `${global.config.sharedServicesUrl}/code-catalog-data-service/get-system-code-values/TASK_STATUS`;
					axios.get(url2)
					.then(response =>{
 					this.setState({circleStatusList : response.data});
					}).catch(function (error) {
						console.log("Error:"+error);
					});		
				//circleContactTypeList
				var url2 = `${global.config.sharedServicesUrl}/code-catalog-data-service/get-system-code-values/CIRCLE_CONTACT_TYPES`;
					axios.get(url2)
					.then(response =>{
 					this.setState({circleContactTypeList : response.data});
					}).catch(function (error) {
						console.log("Error:"+error);
					});		
			}		      	

	}
	
	render(){
    return (
    				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<Link to="/" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</Link>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<Link to="/" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</Link>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="#" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">

	<form>
		<div class="container-fluid">
		<h4>Create Circle</h4>
		<hr />
		

		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Circle Name</label>
		<input id="circleName" class="form-control input-medium col-sm-8" value={this.state.circle.circleName} onChange ={this.handleChange}/>
		</div>

		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Description</label>
			<input id="circleDescr" class="form-control input-medium col-sm-8" value={this.state.circle.circleDescription} onChange ={this.handleChange}/>
		</div>

		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Contacts</label>
			<input id="circleEntry" class="form-control input-medium col-sm-8" value={this.state.circle.circleContacts} onChange ={this.handleChange}/>
		</div>

		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Type</label>
			<select id="projectId" class="form-control input-medium col-sm-8" value={this.state.circle.circleTypeCode} onChange ={this.handleChange}>
			{
				this.state.circleContactTypeList.map((status) => {
					return (
						<option key={status.systemCodeValueId} value={status.systemCodeValueId}>{status.systemCodeValueValue}</option>
					)
				})
			}
			</select>
		</div>

			<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Circle Category</label>
			<select id="circleCategoryCode" class="form-control input-medium col-sm-8" value={this.state.circle.circleCategoryCode} onChange ={this.handleChange}>
			{
				this.state.circleCategoryList.map((status) => {
					return (
						<option key={status.systemCodeValueId} value={status.systemCodeValueId}>{status.systemCodeValueValue}</option>
					)
				})
			}
			</select>
			</div>

			<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Circle Status</label>
			<select id="circleStatusCode" class="form-control input-medium col-sm-8" value={this.state.circle.circleStatusCode} onChange ={this.handleChange}>
			{
				this.state.circleStatusList.map((status) => {
					return (
						<option key={status.systemCodeValueId} value={status.systemCodeValueId}>{status.systemCodeValueValue}</option>
					)
				})
			}
			</select>
			</div>

		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Circle Owner</label>
		<input id="ownerUserId" class="form-control input-medium col-sm-8" value={this.state.circle.ownerUserId} onChange ={this.handleChange}/>
		</div>
		

					
					<button class="btn btn-primary" value="Clear" onClick ={this.handleClear}>Clear</button> &nbsp;
					<button class="btn btn-success" value="Create" onClick ={this.handleSubmit}>Create</button>&nbsp;
		</div>		
	</form>
	
						</div>		

	            </div>	
            </div>
            
			</div>
			</div>
			
	);
}
}